/**
 * 新增 or 编辑
 */
import {useEffect, useRef, useState} from 'react';
import {message} from 'antd';
import {SGeneralForms} from "shj-components";
import {channelMarkSave, channelMarkUpdateById} from "@/services/channelManagement.ts";
import {trimStr} from "@/utils/data.ts";

interface IProps {
  fn: (data?) => void;
  channelId?: number;
  markType?: string;
  record: {};
  editRef: any;
}

export const ModalAddOrEditDom = (props: IProps) => {
  const ref = useRef();
  const {channelId, markType, fn, record = {}} = props;
  const {id} = record;
  const [baseInfo, setBaseInfo] = useState<any>({}); //基础数据

  useEffect(() => {
    initFn();
  }, []);

  const initFn = () => {
    if (id || markType) {
      setBaseInfo({...record});
      ref.current?.onFormRef()?.setFieldsValue({...record, enableFlag: !!record.enableFlag});
    }
  };
  // 提交
  const onFinish = () => {
    return new Promise((resolve, reject) => {
      ref.current?.onFormRef()?.validateFields()
        .then((values) => {
          const newValues = {...baseInfo, ...values, channelId, enableFlag: values.enableFlag ? 1 : 0};
          if (markType) {
            fn && fn(newValues);
            resolve();
          } else {
            const saveFn = newValues.id ? channelMarkUpdateById : channelMarkSave;
            saveFn({data: {...newValues}})
              .then(() => {
                message.success('操作成功');
                fn && fn();
                resolve();
              })
              .catch(() => {
                reject();
              });
          }
        })
        .catch(reject);
    });
  };

  const onReset = () => {
    ref.current?.onFormRef()?.resetFields();
    ref.current?.onFormRef()?.setFieldsValue({enabled: false});
  };

  if (props.editRef) {
    props.editRef.current.onFinish = onFinish;
    props.editRef.current.onReset = onReset;
  }

  return (
    <div>
      <SGeneralForms
        ref={ref}
        initialValues={{enableFlag: false}}
        configs={[{
          formItem: [
            {name: 'markCode', label: '标记编码', required: true, spanCol: 24,
            comConfig:{
              onChange:(e) => ref.current?.onFormRef()?.setFieldValue('markCode', trimStr(e.target.value))
            }},
            {name: 'markName', label: '标记名称', required: true, spanCol: 24,
            comConfig:{
              onChange:(e) => ref.current?.onFormRef()?.setFieldValue('markName', trimStr(e.target.value))
            }},
            {name: 'enableFlag', label: '是否启用', type: 'switch', valuePropName: 'checked', spanCol: 24},
          ]
        }]}/>
    </div>
  );
};
